import { render, staticRenderFns } from "./UploadTray.vue?vue&type=template&id=384f364d&"
import script from "./UploadTray.vue?vue&type=script&lang=ts&"
export * from "./UploadTray.vue?vue&type=script&lang=ts&"
import style0 from "./UploadTray.vue?vue&type=style&index=0&id=384f364d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports